/* global axios */
import ApiClient from './ApiClient';

class ConversationsAnalysisAiApi extends ApiClient {
  constructor() {
    super('conversations_analysis_ai', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }
}

export default new ConversationsAnalysisAiApi();
